module.exports = __webpack_public_path__ + "img/Moderate.fe5033e7.svg";